export default __webpack_public_path__ + "media/flags/fk-79c6cee2.svg";